import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Dashboard from '../pages/ns/dashboard';
// import OperationView from '../pages/ns/dashboard/operation'
import Investigation from '../pages/ns/investigation';
import InvestigationDetail from '../pages/ns/investigationDetail';
import AnalystThroughput from '../pages/ns/analystThroughput';
import SupervisorDashboard from '../pages/ns/supervisorDashboard';
import MatchingConfiguration from '../pages/ns/matchingConfig';
import CreateEditMatchingConfiguration from '../pages/ns/matchingConfig/CreateEditMatchingConfiguration';
import AlertDetail from '../pages/ns/alertDetail';
import MatchingRunInstanceConfiguration from '../pages/ns/matchingRunInstanceConfig';
import CreateMatchingRunInstanceConfiguration from '../pages/ns/matchingRunInstanceConfig/createOrEdit';
import DeployToProduction from '../pages/ns/deployToProduction';
import WatchList from '../pages/ns/watchList';
import WhiteList from '../pages/ns/whiteList';
import Tickets from '../pages/common/tickets';
import Settings from '../pages/settings';
import Segments from '../pages/ns/segments/segments';
import OnDemandScreening from '../pages/ns/onDemandScreening/OnDemandScreening';

import { hasPermission, nsHasPermission } from '../util';
import { getItemFromLocalStorage } from '../util/localStorageUtils';
import {
  NSIAD_TAB_LIST,
  NSIAD_TAB_PAGEID_LIST
} from '../pages/constants/nsConstants';
import {
  ROUTE_AMLS_NS_SAM,
  ROUTE_AMLS_SMART_SCREENING
} from '../pages/constants/globalConstants';
import TicketDetails from '../pages/common/TicketDetails';
import AlertDetails from '../pages/ns/onDemandScreening/AlertDetails';
import { getSelectedResources } from '../util/resourceManager';

const { nsResources } = getSelectedResources();

const NSSettings = () => (
  <Settings
    title="Global Setting for Smart Screening"
    nsTabList={NSIAD_TAB_LIST}
    nsTabPageIdList={NSIAD_TAB_PAGEID_LIST}
    GlobalSettingPageType={'NS'}
  />
);

const TSSettings = () => (
  <Settings
    title="Global Setting for Smart Screening"
    nsTabList={NSIAD_TAB_LIST}
    nsTabPageIdList={NSIAD_TAB_PAGEID_LIST}
    GlobalSettingPageType={'TS'}
  />
);

export default (authentication) => {
  const NoAccess = () => {
    return <div>No Access</div>;
  };

  //protect route by user role
  const RestrictedRender = (Component) => {
    return nsHasPermission(authentication) ? (
      <Component></Component>
    ) : (
      <NoAccess></NoAccess>
    );
  };

  let params = new URLSearchParams(location.search);

  let riskViewPermitted = false;
  let alertsListingPermitted = false;
  let investigationPagePermitted = false;
  let matchingConfigPermitted = false;
  let alertDetailsPermitted = false;
  let nsMatchingRunInstancePermitted = false;
  let nsWatchListPermitted = false;
  let nsWhiteListPermitted = false;
  let globalSettingsPermitted = false;
  let nsSegmentsListingPermitted = false;

  let nsTicketsPermitted = true;
  let nsTicketDetailsPermitted = true;
  let onDemandScreeningPermitted = false;

  let homeUrl = null;

  let productSourceId = null;

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    // list of Attributes
    const listOfAttributes = authentication.data;

    let authData = authentication?.data;

    if (authData) {
      for (let obj of authData) {
        if (
          obj.attributes &&
          Array.isArray(obj.attributes) &&
          obj.attributes.length > 0
        ) {
          let attribute = obj.attributes.find(
            (attr) => attr.attributeKey === 'PRODUCT_SOURCE_ID'
          );
          if (attribute) {
            productSourceId = attribute.attributeValues[0];
            break; // Break the loop once the attribute is found
          }
        }
      }
    }

    listOfAttributes.map((attribute) => {
      const scopes = attribute.details?.resource?.operations
        ? attribute.details.resource.operations
        : null;

      if (scopes) {
        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_ALERTS_LIST)) {
          alertsListingPermitted = true;
        }

        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE)
        ) {
          investigationPagePermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_RISK_VIEW)) {
          riskViewPermitted = true;
        }
        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG)
        ) {
          matchingConfigPermitted = true;
        }
        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_ALERT_DETAILS)
        ) {
          alertDetailsPermitted = true;
        }
        if (
          scopes.includes(
            nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE
          )
        ) {
          nsMatchingRunInstancePermitted = true;
        }
        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_WATCHLIST)) {
          nsWatchListPermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_WHITELIST)) {
          nsWhiteListPermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET)) {
          nsTicketsPermitted = true;
        }
        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_TICKET_DETAILS)
        ) {
          nsTicketDetailsPermitted = true;
        }
        if (
          scopes.includes(
            nsResources.APP_3_RESOURCE_UI_NS_IAD_GLOBAL_SETTINGS
          ) &&
          getItemFromLocalStorage('settings-enabled') === 'true'
        ) {
          globalSettingsPermitted = true;
        }
        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_SEGMENTS)) {
          nsSegmentsListingPermitted = true;
        }
        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_ON_DEMAND_SCREENING)
        ) {
          onDemandScreeningPermitted = true;
        }
      }
    });

    if (investigationPagePermitted) {
      homeUrl = `${ROUTE_AMLS_NS_SAM}/investigation`;
    } else if (riskViewPermitted) {
      homeUrl = `${ROUTE_AMLS_NS_SAM}/dashboard`;
    } else if (matchingConfigPermitted) {
      homeUrl = `${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`;
    } else if (onDemandScreeningPermitted) {
      homeUrl = `${ROUTE_AMLS_SMART_SCREENING}/on-demand-screening`;
    }
  }

  const routes = (
    <Switch>
      {/* <Route exact path="/app/ns/dashboard/operation"
        render={() => {return RestrictedRender(OperationView)}} /> */}

      {/* Render routes based on permissions */}

      {homeUrl ? (
        <Route exact path="/app" render={() => <Redirect to={homeUrl} />} />
      ) : null}

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}`}
        render={() => <Redirect to={homeUrl} />}
      />

      {riskViewPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_NS_SAM}/dashboard`}
          render={() => {
            return RestrictedRender(Dashboard);
          }}
        />
      ) : null}

      {nsSegmentsListingPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/segments`}
          render={() => {
            return RestrictedRender(Segments);
          }}
        />
      ) : null}

      {alertsListingPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_NS_SAM}/investigation`}
          render={() => {
            return RestrictedRender(Investigation);
          }}
        />
      ) : null}
      {/* <Route exact path="/app/ns/investigation/analystthroughput"
        render={() => {return RestrictedRender(AnalystThroughput)}} />
      <Route exact path="/app/ns/investigation/supervisordashboard" 
        render={() => {return RestrictedRender(SupervisorDashboard)}} /> */}

      {investigationPagePermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_NS_SAM}/investigation/:alertId`}
          render={(routeProps) => {
            return (
              <InvestigationDetail
                {...routeProps}
                alertType={params.get('alertType')}
              />
            );
          }}
        />
      ) : null}

      {matchingConfigPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`}
          render={(routeProps) => <MatchingConfiguration {...routeProps} />}
        />
      ) : null}

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/MatchingConfig/create`}
        render={(routeProps) => (
          <CreateEditMatchingConfiguration {...routeProps} />
        )}
      />

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/MatchingConfig/:id/view`}
        render={(routeProps) => (
          <CreateEditMatchingConfiguration {...routeProps} />
        )}
      />

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/MatchingConfig/:id/edit`}
        render={(routeProps) => (
          <CreateEditMatchingConfiguration {...routeProps} />
        )}
      />

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/MatchingConfig/:id/edit`}
        render={(routeProps) => (
          <CreateEditMatchingConfiguration {...routeProps} />
        )}
      />

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/investigation/:id`}
        render={(routeProps) => <AlertDetail {...routeProps} />}
      />

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/runInstance/:id/deployInProduction`}
        render={(routeProps) => <DeployToProduction {...routeProps} />}
      />

      {nsMatchingRunInstancePermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/runInstance`}
          render={(routeProps) => (
            <MatchingRunInstanceConfiguration {...routeProps} />
          )}
        />
      ) : null}

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/runInstance/create`}
        render={() => <CreateMatchingRunInstanceConfiguration />}
      />

      {nsWatchListPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/watchlist`}
          render={(routeProps) => <WatchList {...routeProps} />}
        />
      ) : null}

      {nsWhiteListPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/whitelist`}
          render={(routeProps) => <WhiteList {...routeProps} />}
        />
      ) : null}

      {globalSettingsPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/settings`}
          render={() => {
            if (productSourceId == '9') {
              return RestrictedRender(TSSettings);
            }
            return RestrictedRender(NSSettings);
          }}
        />
      ) : null}

      {nsTicketsPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/tickets`}
          render={(routeProps) => <Tickets {...routeProps} />}
        />
      ) : null}

      {nsTicketDetailsPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/tickets/:id`}
          render={(routeProps) => <TicketDetails {...routeProps} />}
        />
      ) : null}

      {onDemandScreeningPermitted ? (
        <Route
          exact
          path={`${ROUTE_AMLS_SMART_SCREENING}/on-demand-screening`}
          component={OnDemandScreening}
        />
      ) : null}

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}/alert/:alertId/:tabId`}
        render={(routeProps) => <AlertDetails {...routeProps} />}
      />
    </Switch>
  );
  return routes;
};
